import {
  FlexibleBlockBrickProcessAction,
  FlexibleBlockProps,
  FlexibleBlockTemplateProcessAction,
  PortalBgType,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils';
import { brickCommon } from './common';

export const getProcessActionBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateProcessAction>[] => {
  const BrickProcessAction: FlexibleBlockBrickProcessAction = {
    ...brickCommon,
    brickName: 'Buttons',
    brickType: 'process-action',
    relatedMenuItemId: '',
    buttons: {
      start: {
        name: 'Start process button',
        state: {
          active: {
            text: 'Start process',
            icon: 'ARROW_FORWARD',
          },
        },
      },
      continue: {
        name: 'Continue process button',
        state: {
          active: {
            text: 'Continue process',
            icon: 'ARROW_FORWARD',
          },
        },
      },
      complete: {
        name: 'Complete step button',
        state: {
          active: {
            text: 'Complete step and continue',
            icon: 'ARROW_FORWARD',
          },
          done: {
            text: 'Step completed',
            icon: 'CHECK',
          },
        },
      },
      incomplete: {
        name: 'Incomplete step button',
        state: {
          active: {
            text: 'Incomplete step',
            icon: 'SYNC',
          },
        },
      },
      return: {
        name: 'Return button',
        state: {
          active: {
            text: 'Return to start and review steps',
          },
        },
      },
      finish: {
        name: 'Finish button',
        state: {
          active: {
            text: 'Complete process',
            icon: 'ARROW_FORWARD',
          },
          done: {
            text: 'Process completed',
            icon: 'CHECK',
          },
        },
      },
      navigation: {
        name: 'Navigation buttons',
        state: {
          prev: {
            text: '',
            icon: 'ARROW_2_LEFT',
          },
          next: {
            text: '',
            icon: 'ARROW_2_RIGHT',
          },
        },
      },
    },
    theme: {
      bg: {
        default: PortalBgType.SECONDARY,
        hover: PortalBgType.SECONDARY_HOVER,
      },
      text: {
        default: PortalTextType.SECONDARY,
      },
    },
    className: ['justify-between'],
  };

  return [
    {
      title: 'Process buttons',
      template: {
        type: 'process-action',
        view: 'basic',
      },
      bricks: [{ ...BrickProcessAction, index: 0 }],
      wrapper: { ...getWrapperProps('custom'), showTitle: false, className: ['p-4'] },
    },
  ];
};
